module.exports = __webpack_public_path__ + "img/ws.3ea6d44f.svg";